import React from 'react';

import styles from './styles.module.css';

interface TextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  id?: string;
}

export const TextArea = ({
  label,
  id,
  ...props
}: TextAreaProps): JSX.Element => (
  <div className={styles.container}>
    {label && (
      <h3 className={styles.label} id={id}>
        {label}
      </h3>
    )}
    <textarea id={id} {...props} className={styles.textarea} />{' '}
  </div>
);
